import { useCallback, useEffect, useRef } from 'react';
import { KycProcessStatus } from '@repo/api-kit/queries/due-diligence/kyc';
import { isKycProviderSucceeded } from '#utils/kyc-provider-status';

type KycProcessStatusValue = (typeof KycProcessStatus)[keyof typeof KycProcessStatus];

// Returned markComplete lets a caller suppress a still-pending fire when it learns of
// completion from another source (e.g. an SDK completion event) before processStatus flips.
export function useKycCompletion(
  processStatus: KycProcessStatusValue | undefined,
  onComplete: () => void,
  providerStatus?: string
): () => void {
  const completedRef = useRef(false);
  const isComplete =
    isKycProviderSucceeded(providerStatus) || processStatus === KycProcessStatus.submitted;

  useEffect(() => {
    return () => {
      completedRef.current = true;
    };
  }, []);

  useEffect(() => {
    if (isComplete && !completedRef.current) {
      completedRef.current = true;
      onComplete();
    }
  }, [isComplete, onComplete]);

  return useCallback(() => {
    completedRef.current = true;
  }, []);
}
